import { renameAllShortInAString } from '@src/utils/common';
interface IError {
  causesVpf: boolean;
  causesVsf: boolean;
}
type Impact = 'N/A' | 'VSF' | 'VPF' | 'VSF + VPF' | '';
export default (error: IError): Impact => {
  let errorType: Impact = '';
  if (error.causesVpf) {
    errorType = 'VPF';
  }
  if (error.causesVsf) {
    errorType = errorType ? 'VSF + VPF' : 'VSF';
  }
  return renameAllShortInAString(errorType) || 'N/A';
};
